export default __webpack_public_path__ + "static/media/MickeyLovelace.16d3d7be.png";